module.exports = function () {
    
    var $videoHeroBottom = $('.video-hero-bottom');

    var updateBottomMargin = function () {
        var height = $videoHeroBottom.outerHeight(true) / 2 * -1;

        $videoHeroBottom.find('.video-hero-bottom__container').css({
            'margin-bottom': height + 'px'
        });
    };

    if ($videoHeroBottom.length) {
        updateBottomMargin();

        $(window).resize(function () {
            requestAnimationFrame(updateBottomMargin);
        });
    }
};